import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Receipt, Users } from "lucide-react";
import { api, fmtINR } from "@/lib/api";

export const PrincipalBilling = ({ auth }) => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/principal/billing", auth).then((r) => setD(r.data)).catch(() => setD({ invoices: [], roster: [] })); }, [auth]);
  if (!d) return null;
  return (
    <div className="mt-10 grid lg:grid-cols-2 gap-5" data-testid="principal-billing">
      <div className="bg-white rounded-2xl border border-slate-200 p-5">
        <h2 className="font-bold text-[#0A192F] flex items-center gap-2"><Receipt className="w-4 h-4 text-[#FF2E63]" />Centralised billing</h2>
        {d.invoices.length ? d.invoices.map((i) => (
          <div key={i.invoice_no} className="mt-3 flex items-center justify-between gap-3 border-t pt-3 text-sm" data-testid={`principal-invoice-${i.invoice_no}`}>
            <div><b>{i.invoice_no}</b> · <span className="capitalize">{i.area} · {i.billing}</span><div className="text-xs text-slate-500">{fmtINR(i.base_fee_inr)} − {i.discount_pct}% = <b className="text-[#0A192F]">{fmtINR(i.total_inr)}</b> · {i.roster_count} students</div></div>
            {i.payment_status === "paid" ? <span className="text-green-700 font-bold text-xs">PAID</span>
              : <Link to={`/school-billing/${i.token}`} className="rs-cta rounded-full px-4 py-1.5 text-xs font-bold whitespace-nowrap" data-testid={`principal-pay-${i.invoice_no}`}>Pay now</Link>}
          </div>)) : <p className="text-sm text-slate-500 mt-3">No bills yet. Apply on the Schools page to get an onboarding bill with 20–30% off.</p>}
        <p className="text-[11px] text-slate-500 mt-3">Fees cover classroom + lab assistance only. Kits are not included.</p>
      </div>
      <div className="bg-white rounded-2xl border border-slate-200 p-5">
        <h2 className="font-bold text-[#0A192F] flex items-center gap-2"><Users className="w-4 h-4 text-[#007A8A]" />Bulk roster ({d.roster.length})</h2>
        <div className="mt-3 max-h-64 overflow-y-auto text-sm" data-testid="principal-roster">
          {d.roster.map((s, i) => <div key={i} className="flex justify-between border-t py-1.5"><span>{s.student_name}</span><span className="text-slate-500">Class {s.class_grade}</span></div>)}
          {!d.roster.length && <p className="text-slate-500">No roster uploaded yet.</p>}
        </div>
      </div>
    </div>
  );
};
